import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Report } from '../interfaces';
import { environment } from './../../../environments/environment';

export interface Reports {
  '@odata.context': string;
  value: Report[];
}

export class ReportTreeItem {
  // id: string;
  // text: string;
  // description: string;
  // modified: Date;
  leaf?: boolean;
  expanded?: boolean;
  items?: ReportTreeItem[];

  constructor(public id: string, public text: string, public description: string, public modified: Date) {
    // this.id = id;
    // this.text = text;
    // this.description = description;
    // this.modified = modified;
    this.leaf = true;
    this.expanded = true;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ReportService {

  isMysqlDriver: boolean;

  constructor(private httpClient: HttpClient) {
    this.isMysqlDriver = environment.DB_DRIVER === "mysql" || false;
  }

  getReportData(reportId: string, lang: string): Observable<Report> {

    const reportDataUrl = (this.isMysqlDriver)
      ? `/odata/v4/public/Report?$select=title_${lang},description_${lang},uom_${lang},grp,details_${lang},modified,chart_default,chart_show,chart_inverted&$filter=id eq '${reportId}'`
      : `/odata/v4/public/Report?$select=title_${lang},description_${lang},uom_${lang},grp,details_${lang},modifiedAt,chart_default,chart_show,chart_inverted&$filter=id eq '${reportId}'&$expand=batches($filter=public eq true;$orderby=modifiedAt desc)`;

    return this.httpClient
      .get<Reports>(reportDataUrl)
      .pipe<Report>(map((report) => report.value[0]));
  }

  getReports(lang: string): Observable<Reports> {
  
    const reportsUrl = (this.isMysqlDriver)
    ? `/odata/v4/public/Report?$select=id,title_${lang},description_${lang},uom_${lang},modified,grp,subgrp&$orderby=subgrp,ord&$expand=batches($select=id,public,modified;$orderby=modified desc;$filter=(public eq true) and modify_action ne 'DELETE')`
    : `/odata/v4/public/Report?$select=id,title_${lang},description_${lang},uom_${lang},modifiedAt,grp,subgrp&$orderby=subgrp,ord&$expand=batches($select=id,public,modifiedAt;$orderby=modifiedAt desc;$filter=(public eq true) and modify_action ne 'DELETE')`;

    return this.httpClient.get<Reports>(reportsUrl);
  }

  getTreeNodes(lang: string): Observable<any> {

    const treeNodesUrl = (this.isMysqlDriver)
    ? `/odata/v4/public/Report?$orderby=grp,subgrp,ord&$apply=groupby((grp,subgrp))`
    : `/odata/v4/public/Report?$orderby=grp,subgrp&$apply=groupby((grp,subgrp))`;

    return this.httpClient.get<Reports>(treeNodesUrl)
  }
}
